"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const Titleheading = () => {
  return (
    <div>
      <section className="relative py-10 md:py-20 lg:py-48 -z-20 before:-z-10 before:bg-opacity-20">
        {/* Background Image using Next.js Image tag */}
        <Image
          src="/images/mice-event-bg.jpg"
          alt="MICE, Events & Leisure Travel | Expert Event Management"
          fill
          className="absolute top-0 left-0 w-full h-full -z-10 object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-30 z-0"></div>
      </section>
    </div>
  );
};

export default Titleheading;
